import { UtilityService } from '@eforall/common';
import { DialogService, GridSetup } from '@eforall/dashboard';
import { AcceleratorAreaService } from '../../../../../accelerator-area.service';
import { AccEntrepreneur } from '../acc-entrepreneurs-view.part';
import { getActions } from './get-actions';
import { getColumns } from './get-columns';


export function getSetup(util: UtilityService, dialog: DialogService, areaService: AcceleratorAreaService): GridSetup<AccEntrepreneur> {

	return {
		rowName: { singular: 'Entrepreneur', plural: 'Entrepreneurs' },
		getRowKey: row => '' + row.accEntrepreneurId,
		renderRowClasses: row => (row.absences ?? 0) > 3 && row.ventureStatus == 'Participating' ? ['grid-cell-red-text'] : [],
		stateKey: 'accelerator-entrepreneurs-grid',
		actions: getActions(dialog, areaService),
		buttons: [],
		columns: getColumns(util),
	}
}
